import { GridItem } from '@bnnvara/grids';
import { SterBanner } from '@bnnvara/ster';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';

const ComposableCardListSterBanner = ({ bannerType }) => {
  const { route } = useRouter();

  return (
    <GridItem
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 3"
      columnEndXl="span 3"
    >
      <SterBanner bannerType={bannerType} page={route} />
    </GridItem>
  );
};

ComposableCardListSterBanner.propTypes = {
  bannerType: PropTypes.oneOf(['homepage', 'artikelen', 'overig']).isRequired,
};

export default ComposableCardListSterBanner;
